<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <button
      type="button"
      id="decline_tender"
      :class="className"
      @click="init()"
    >{{ $t('action.reject') }}</button>

    <div
      class="reveal"
      :id="'specifyReasonModal' + id"
      data-reveal
    >
      <div class="modal-container">
        <p class="confirm-header">{{ $t('tender.tmview.rejectHint') }}</p>
        <label class="emphasis">{{ $t('comment') }}</label>
        <textarea
          type="text"
          v-autosize
          class="autosize"
          v-model="rejectReason"
          :placeholder="$t('tender.tmview.rejectPlaceholder')"
          required
        />
        <span
          class="form-error is-visible appr-error-message"
          v-if="apprErrHint"
        >
          {{ apprErrHint }}
        </span>
      </div>
      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeSpecifyReasonModal()"
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="submit"
          class="btn btn--orange"
          @click="reject()"
        >{{ $t('action.reject') }}</button>
      </div>
    </div>

    <Modal
      :modalId="'confirmMessageModal' + id"
      ref="confirmMessageModal"
    >
      <div slot="content">
        <p class="modal-pure-text">{{ $t('hint.confirmTenderDecline') }}</p>
      </div>
      <div slot="btns">
        <button
          type="submit"
          class="btn btn--orange"
          @click="closeModal()"
        >{{ $t('hint.okay') }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import router from '@/router'
import notification from '@/utils/notification'
import { tenderStatus } from '@/utils/locale'
import { sendEmail } from '@/api/postman/request'
import { EmailTypes, ActionTypes } from '@/utils/consts'
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/controls/Modal'

export default {
  name: 'RejectTender',
  components: {
    Modal,
  },
  data () {
    return {
      apprErrHint: '',
      rejectReason: '',
      tenderId: null,
    }
  },

  props: {
    className: {
      type: String,
      default: 'btn btn--darkblue',
    },
    tenderInfo: {
      type: Object,
    },
    id: {
      type: String,
      default: '',
    },
  },

  mounted () {
    this.tenderId = router.currentRoute.params.id
  },

  methods: {
    ...mapActions('tenders', [
      'refreshTender',
      'updateTenderStatus',
    ]),
    openSpecifyReasonModal () {
      this.specifyReasonModal.open()
    },
    closeSpecifyReasonModal () {
      this.specifyReasonModal.close()
    },
    openConfirmMessageModal () {
      this.confirmMessageModal.open()
    },
    closeConfirmMessageModal () {
      this.confirmMessageModal.close()
    },
    async reject () {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.apprErrHint = this.$i18n.t('hint.enterRejectReason')
      } else {
        const status = tenderStatus.REJECTED
        const action = this.isAddendum ? ActionTypes.tenders.addendum.reject : ActionTypes.tenders.reject
        const request = {
          id: this.tenderId,
          status,
          action,
          historyDetail: { rejectReason: this.rejectReason },
        }
        const notificationPrefix = this.$i18n.t('tender.reject')
        await this.updateTender(request, notificationPrefix)
        await sendEmail(EmailTypes.tenders.approvalResult, {rejectReason: this.rejectReason, isAddendum: this.isAddendum})
        this.closeSpecifyReasonModal()
        this.openConfirmMessageModal()
      }
    },

    async updateTender (request, prefix, callback) {
      try {
        await this.updateTenderStatus(request)
        this.allowEdit = false
        this.readonly = true
        if (callback) {
          await callback()
        }
      } catch (err) {
        notification.handleResponseError(err, prefix)
        throw err
      }
    },

    async closeModal () {
      this.closeConfirmMessageModal()
      await this.refreshTender()
    },

    async init () {
      if (!this.specifyReasonModal) {
        this.specifyReasonModal = await new Foundation.Reveal($(`#specifyReasonModal${this.id}`), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      if (!this.confirmMessageModal) {
        this.confirmMessageModal = this.$refs.confirmMessageModal
      }
      await this.openSpecifyReasonModal()
    },
  },
  computed: {
    ...mapGetters('tenders', {
      isAddendum: 'isAddendum',
    }),
  },
  destroyed () {
    if (this.specifyReasonModal) {
      this.specifyReasonModal.close()
      this.specifyReasonModal.destroy()
    }
    $('#specifyReasonModal').remove()

    if (this.confirmMessageModal) {
      this.confirmMessageModal.close()
      this.confirmMessageModal.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
@import "~styles/stickyBtn";

.appr-error-message {
  margin-top: 10px;
}

.modal-container textarea {
  width: 100%;
}

.emphasis {
    font-weight: bold;
    color: #0C3A58;
    margin-bottom: 5px;
}

</style>
